import React, { createContext, useContext } from "react";
import { AppContextActions } from "./app-actions";
import { AppModel, DateFilterType } from "./app-model";
import moment from "moment";

export interface AppContextProps {
  actions: AppContextActions;
  model: AppModel;
}

type AppContextState = AppContextProps;

export const AppContext = createContext({} as AppContextProps);

export class AppProvider extends React.Component<{}, AppContextState> {
  constructor(props: any) {
    super(props);
    const defaultDate = new Date();
    const defaultComparableDate = moment(new Date()).add(-1, "d").toDate();

    this.state = {
      model: {
        tenants:[],
        filtroModel: {
          dateFilterType: DateFilterType.diario,
          dateFilter: defaultDate,
          comparableDateFilter: defaultComparableDate,
        },
      },
      actions: new AppContextActions(this),
    };
  }

  setProviderState(model: AppModel, callback?: () => void) {
    this.setState({ ...this.state, model: model }, callback);
  }

  render() {
    return (
      <AppContext.Provider value={this.state}>
        {this.props.children}
      </AppContext.Provider>
    );
  }
}

export const useAppContext = (): AppContextProps => useContext(AppContext);
